import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { createMyCarByModel } from '../request/carApis'

import type { ICreateMyCarByModelSuccessResponse } from '@/entities/car/model'
const useCreateMyCarByModelMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: ICreateMyCarByModelSuccessResponse) => void
  onError?: (error: AxiosError) => void
}) => {
  return useMutation({
    mutationFn: createMyCarByModel,
    onSuccess,
    onError,
    throwOnError: false,
    retry: false,
  })
}

export default useCreateMyCarByModelMutation
